import Service from "./Service";

const baseurl = '/api/logs-deleted-results';

export default {
    store(obj) {
        return Service.post(`${baseurl}/store`, obj);
    },
    index(search = '', pagination = {}) {
        return Service.get(`${baseurl}`, {
            params: {
                search,
                ...pagination
            }
        });
    }
};
